"use strict";

/**
 * You can use this file for your Drupal behavious
 */

(function ($, Drupal) {
  /**
   * Fixed menu behaviour
   */
  Drupal.behaviors.wildcom2018FixedMenu = {
    attach: function (context) {
      $(once (
          "wildcom2018-fixed-menu",
          "body", context
      )).each(function () {
          // Only use fixed menu for tablet portrait layout and up
          if (screen.width >= 600) {
            if ($('.site-header-inner').length > 0) {

              const innerHeader = document
                .querySelectorAll(".site-header-inner")
                .item(0);
              let blockSocialMedia = document.getElementById(
                "block-wildcom2018-socialmedialinks"
              );
              let blockDonate = document.getElementById(
                "block-wildcom2018-headerdonatebutton"
              );

              // Getting positions
              // https://stackoverflow.com/questions/442404/retrieve-the-position-x-y-of-an-html-element
              const bodyRect = document.body.getBoundingClientRect();
              const inHeaderRect = innerHeader.getBoundingClientRect();
              const bSMRect = blockSocialMedia.getBoundingClientRect();
              const bDRect = blockDonate.getBoundingClientRect();

              // Save right offset from Site Header Inner, this will be needed when window resize
              blockSocialMedia.dataset.rightOffset = Math.round(
                inHeaderRect.right - bSMRect.right
              );
              blockDonate.dataset.rightOffset = Math.round(
                inHeaderRect.right - bDRect.right
              );

              // Setting fixed position
              blockSocialMedia.style.position = "fixed";
              blockSocialMedia.style.right =
                Math.round(bodyRect.right - bSMRect.right) + "px";
              blockSocialMedia.style.top =
                Math.round(bSMRect.top - bodyRect.top) + "px";

              blockDonate.style.position = "fixed";
              blockDonate.style.right =
                Math.round(bodyRect.right - bDRect.right) + "px";
              blockDonate.style.top =
                Math.round(bDRect.top - bodyRect.top) + "px";

              // Create fixed top bar
              let topBar = document.createElement("div");
              topBar.setAttribute("id", "fixed-top-bar");
              topBar.style.top = Math.round(bDRect.top - bodyRect.top) + "px";
              document.body.insertBefore(topBar, document.body.firstChild);

              // Reference: http://www.html5rocks.com/en/tutorials/speed/animations/
              let lastKnownScrollPosition = 0;
              let ticking = false;

              window.addEventListener("scroll", function () {
                lastKnownScrollPosition = window.scrollY;
                if (!ticking) {
                  window.requestAnimationFrame(function () {
                    if (lastKnownScrollPosition > 0) {
                      document.body.classList.add("sticky-header");
                    }
                    else {
                      document.body.classList.remove("sticky-header");
                    }
                    ticking = false;
                  });
                  ticking = true;
                }
              });

              window.onresize = function () {
                if (screen.width < 600) {
                  blockSocialMedia.style.removeProperty("position");
                  blockSocialMedia.style.removeProperty("top");
                  blockSocialMedia.style.removeProperty("right");

                  blockDonate.style.removeProperty("position");
                  blockDonate.style.removeProperty("top");
                  blockDonate.style.removeProperty("right");
                }
                else {
                  let bodyRect = document.body.getBoundingClientRect();
                  let inHeaderRect = innerHeader.getBoundingClientRect();

                  // Update right offsets
                  blockSocialMedia.style.right =
                    Math.round(
                      Number(bodyRect.right) -
                      Number(inHeaderRect.right) +
                      Number(blockSocialMedia.dataset.rightOffset)
                    ) + "px";
                  blockDonate.style.right =
                    Math.round(
                      Number(bodyRect.right) -
                      Number(inHeaderRect.right) +
                      Number(blockDonate.dataset.rightOffset)
                    ) + "px";
                }
              };
            }
          }
        });
    },
  };

  /**
   * Mobile menu behaviour
   */
  Drupal.behaviors.wildcom2018MobileMenu = {
    attach: function (context) {
      $(context)
        {
            $(once(
              "wildcom2018-mobile-menu",
                "#mobile-menu-trigger", context
                ))
                .click(function () {
                    if (document.body.classList.contains("mobile-menu-open")) {
                        document.body.classList.remove("mobile-menu-open");
                    } else {
                        document.body.classList.add("mobile-menu-open");
                    }
                    return false;
                });
        }
    },
  };

  /**
   * Toggle display of search form
   *
   * @param {Object} event - click event
   */
  function wildcom2018TogglerSearchHandler(event) {
    const $form = $(event.data.form);
    const $txtField = $("input.form-search", $form);

    $(this).blur();

    if ($txtField.is(":visible")) {
      if ($txtField.val()) {
        $form.submit();
      }
      else {
        // $form.addClass('hidden');
        $txtField.hide();
      }
    }
    else {
      // $form.removeClass('hidden');
      $txtField.show();
      $txtField.focus();
    }

    return false;
  }

  Drupal.behaviors.wildcom2018ToggleSearch = {
    attach: function (context) {
        $(once(
            "wildcom2018-toggle-search",
            "#search-block-form", context
        )).each(function () {
          const $searchTrigger = $('<a href="#" class="icon-search"></a>');

          $searchTrigger.on(
            "click",
            { form: this },
            wildcom2018TogglerSearchHandler
          );
          $searchTrigger.appendTo(this);

          // $('input.form-submit', this).on('click', {'form': this}, wildcom2018TogglerSearchHandler);
        });
    },
  };

  Drupal.behaviors.wildcom2018ToggleFieldOffices = {
    attach: function (context) {
        $(once(
            "wildcom2018-toggle-field-offices",
            "#block-fieldoffices", context
        )).each(function () {
          const $trigger = $(this).children("h2").first();
          const $block = $(this);

          $trigger.on("click", function (e) {
            $block.toggleClass("expanded");
            e.stopPropagation();
          });

          $(document).on("click", function (e) {
            if ($(e.target).is($trigger) === false) {
              $block.removeClass("expanded");
            }
          });
        });
    },
  };

  Drupal.behaviors.wildcom2018SignUpNewsletter = {
    attach: function (context) {
        $(once(
            "wildcom2018-signup-newsletter",
            ".webform-submission-e-alerts-signup-add-form", context
        )).each(function () {
          const block = this;
          $(this).addClass("collapsed");

          $(".form-email", this).focus(function () {
            $(block).removeClass("collapsed");
          });
        });
    },
  };
  Drupal.behaviors.captionClean = {
    attach: function () {
      $(".image-caption").each(function (v, i) {
        let $item = $(i);
        let $itemLenght = $item.html().length;

        if ($itemLenght === 2) {
          $item.addClass("empty");
        }
      });
    },
  };
})(jQuery, Drupal);
